// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1KIxk","col":"CardReaderDesc_col__2lkEu","label":"CardReaderDesc_label__E46Yx"};